import RCPagination, {PaginationProps} from 'rc-pagination';
import React from 'react';
import 'rc-pagination/assets/index.css';
import {ArrowPrevIcon} from '@/_application/icons/arrow-prev';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import cn from 'classnames';

const buttonClassName =
    'group flex h-8 w-8 items-center justify-center rounded-full bg-white text-primary-100 shadow-productCard transition-colors after:hidden! hover:bg-primary-100';
const iconClassName = 'h-3! w-3! text-primary-100 transition-colors group-hover:text-white';

const DefaultPreviousIcon = (
    <button aria-label="Trang trước" className={buttonClassName}>
        <ArrowPrevIcon className={iconClassName} />
    </button>
);
const DefaultNextIcon = (
    <button aria-label="Trang tiếp theo" className={buttonClassName}>
        <ArrowNextIcon className={iconClassName} />
    </button>
);
const DefaultItemRender = (current: number, type: string, element: React.ReactNode): React.ReactNode => {
    if (type === 'page') {
        const pageClass = cn(
            'font-bold shadow-productCard rounded-full text-primary-100 hover:bg-primary-100 hover:text-white transition-colors h-8 w-8 cursor-pointer',
        );
        return (
            <button aria-label="Phân trang" className={pageClass}>
                {current}
            </button>
        );
    }
    return element;
};

const Pagination: React.FC<PaginationProps> = props => {
    const NextIcon = props.nextIcon ?? DefaultNextIcon;
    const PreviousIcon = props.prevIcon ?? DefaultPreviousIcon;
    const ItemRender = props.itemRender ?? DefaultItemRender;

    return <RCPagination nextIcon={NextIcon} prevIcon={PreviousIcon} itemRender={ItemRender} {...props} />;
};

export default Pagination;
